
import 'slick-carousel';

$('.js-ho-2-optimised-range').slick({
  dots: true,
  infinite: false,
  fade: false,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});
